const EM_DASH = '—';

const isValidNumber = (value: number | null | undefined): value is number =>
  typeof value === 'number' && Number.isFinite(value);

const isValidDenominator = (
  denominator: number | null | undefined,
): denominator is number => isValidNumber(denominator) && denominator !== 0;

export const formatCount = (value: number | null | undefined): string => {
  if (!isValidNumber(value)) {
    return EM_DASH;
  }

  return new Intl.NumberFormat('ru-RU').format(value).replace(/\u00A0/g, ' ');
};

export const formatPercent = (
  numerator: number,
  denominator: number | null | undefined,
  decimals = 2,
): string => {
  if (!isValidDenominator(denominator)) {
    return EM_DASH;
  }

  return `${((numerator / denominator) * 100).toFixed(decimals)}%`;
};

export const safeRatio = (
  numerator: number,
  denominator: number | null | undefined,
  decimals = 1,
): string => {
  if (!isValidDenominator(denominator)) {
    return EM_DASH;
  }

  return (numerator / denominator).toFixed(decimals);
};
